import segmentBar from './segmentBar';
export default segmentBar;



// WEBPACK FOOTER //
// ./src/components/segmentBar/index.js